<nz-modal [(nzVisible)]="isVisibleBalanceTransferModal"
    nzClassName="siteModal site-edit-modal invoice-modal transfer-detail-modal" [nzTitle]="titleTemplate"
    (nzOnCancel)="handleCancel(null)" [nzFooter]="footerTpl" nzCentered>

    <ng-template #titleTemplate let-control>
        Journal Entry

{{getInternalTransferDetail && getInternalTransferDetail.journalNo ? getInternalTransferDetail.journalNo :''}}
<span nz-icon nzType="sync" nzTheme="outline" [nzSpin]="isResyncingData" (click)="resynInternalTransferData()" class="ml-1 x-lg" nz-tooltip [nzTooltipTitle]="isResyncingData ? 'Syncing...' : 'Resync Internal Transfer'"></span>
    </ng-template>
    <ng-container *nzModalContent class="h-100">
<div style="overflow: auto; height: 75vh" cdkScrollable>
        <div class="page-padding bg-white-color">
            <!-- <p class="transfer-id-text">Transfer ID <span >{{getInternalTransferDetail?.journalId}}</span> </p> -->
            <p class="investment-company-name pb-0 width-100">
                <a target="_blank" [href]="qboURL + '/app/journal?txnId='+getInternalTransferDetail?.journalId" class="border">Journal Entry No. : {{getInternalTransferDetail?.journalNo}}</a>
            </p>
            <!-- <p class="investment-company-name pb-0 width-100"> -->
                <!-- <a target="_blank" [href]="qboURL + '/app/journal?txnId='+getInternalTransferDetail?.journalId" class="border">Journal Entry ID : {{getInternalTransferDetail?.journalId}}</a> -->
            <!-- </p> -->

            <div nz-row class="d-flex align-i-c invoice-title-padding">
                <div nz-col nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="24">
                    <h1 class="page-title-text tab-title">Transfer Detail</h1>
                </div>
            </div>
        </div>

        <div class="page-padding bg-white-color">
            <div class="detail-box padding-0" nz-row>
                <div nz-col class="quickbooks-bg-color">
                    <div class="box-padding">
                        <nz-skeleton *ngIf="this.isLoadingInternalfr" [nzParagraph]="{ rows: 8,width: 8}"
                        [nzActive]="true"></nz-skeleton>
                        <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="24" *ngIf="!this.isLoadingInternalfr" >
                            <div class="d-flex align-i-c mb-1">
                                <label class="investment-approve-label-text">User</label>
                                <p class="investment-company-name pb-0 width-100">
                                    <span *ngIf="(getInternalTransferDetail?.user != null && getInternalTransferDetail?.user != '') else elsepart ">{{getInternalTransferDetail?.user}}</span>
                                </p>
                            </div>
                            <div class="d-flex align-i-c mb-1">
                                <label class="investment-approve-label-text">Submitted</label>
                                <p class="investment-company-name pb-0 width-100">
                                    <span *ngIf="(getInternalTransferDetail?.syncOn != null && getInternalTransferDetail?.syncOn != '') else elsepart ">{{getInternalTransferDetail?.syncOn | date:'MM/dd/yyyy'}}</span>
                                </p>
                            </div>
                            <div class="d-flex mb-1">
                                <label class="investment-approve-label-text">Memo</label>
                                <p class="investment-company-name pb-0 width-100">
                                    <span class="multiline-text" *ngIf="(getInternalTransferDetail?.memo != null && getInternalTransferDetail?.memo != '') else elsepart ">  {{getInternalTransferDetail?.memo}}</span>
                                </p>
                            </div>
                            <div class="d-flex align-i-c mb-1">
                                <label class="investment-approve-label-text">Journal No</label>
                                <p class="investment-company-name pb-0 width-100">
                                    <span *ngIf="(getInternalTransferDetail?.journalNo != null && getInternalTransferDetail?.journalNo != '') else elsepart ">{{getInternalTransferDetail?.journalNo}}</span>
                                </p>
                            </div>
                            <div class="d-flex align-i-c mb-1">
                                <label class="investment-approve-label-text">Journal Date</label>
                                <p class="investment-company-name pb-0 width-100">
                                    <span *ngIf="(getInternalTransferDetail?.journalDate != null && getInternalTransferDetail?.journalDate != '') else elsepart ">{{getInternalTransferDetail?.journalDate?.toString()?.slice(0,-1)  | date:'MM/dd/yyyy'}}</span>
                                </p>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div class="detail-box debit-detail-box" nz-row>
                <div class="quickbooks-bg-color">
                    <div class="box-padding border-bottom" nz-row [nzGutter]="{ xs: 8, sm: 15, md: 15, lg: 20 }">
                        <nz-skeleton *ngIf="this.isLoadingInternalfr" [nzParagraph]="{ rows: 8,width: 8}"
                        [nzActive]="true"></nz-skeleton>
                        <div nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="12" nzXl="12" *ngIf="!this.isLoadingInternalfr">
                            <div class="d-flex align-i-c mb-1">
                                <h1 class="page-title-text tab-title debit-color">Debit</h1>
                            </div>
                            <div class="d-flex align-i-c mb-1">
                                <label class="investment-approve-label-text">Account</label>
                                <p class="investment-company-name pb-0 width-100">
                                    <span *ngIf="(getInternalTransferDetail?.debitEntry?.account?.name != null && getInternalTransferDetail?.debitEntry?.account?.name != '') else elsepart ">{{getInternalTransferDetail?.debitEntry?.account?.name}}</span>
                                </p>
                            </div>
                            <div class="d-flex align-i-c mb-1">
                                <label class="investment-approve-label-text">Class</label>
                                <p class="investment-company-name pb-0 width-100">
                                    <span *ngIf="(getInternalTransferDetail?.debitEntry?.class?.name != null && getInternalTransferDetail?.debitEntry?.class?.name != '') else elsepart ">{{getInternalTransferDetail?.debitEntry?.class?.name}}</span>
                                </p>
                            </div>
                            <div class="d-flex mb-1">
                                <label class="investment-approve-label-text">Description</label>
                                <p class="investment-company-name pb-0 width-100" #debitDesc [ngStyle]="{'height':maxDescHeight + 'px'}">
                                    <span *ngIf="(getInternalTransferDetail?.debitEntry?.description != null && getInternalTransferDetail?.debitEntry?.description != '') else elsepart ">{{getInternalTransferDetail?.debitEntry?.description}}</span>
                                </p>
                            </div>
                            <div class="d-flex align-i-c mb-1">
                                <label class="investment-approve-label-text">Amount</label>
                                <p class="investment-company-name pb-0 width-100">
                                    <span *ngIf="(getInternalTransferDetail?.debitEntry?.amount != null && getInternalTransferDetail?.debitEntry?.amount != '') else elsepart ">{{getInternalTransferDetail?.debitEntry?.amount | currency}}</span>
                                </p>
                            </div>
                            <div class="d-flex align-i-c mb-1">
                                <label class="investment-approve-label-text">Net</label>
                                <p class="investment-company-name pb-0 width-100">
                                    <span *ngIf="(getInternalTransferDetail?.debitEntry?.amount != null && getInternalTransferDetail?.debitEntry?.amount != '') else elsepart ">-{{getInternalTransferDetail?.debitEntry?.amount | currency}}</span>
                                </p>
                            </div>
                        </div>
                        <div nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="12" nzXl="12" *ngIf="!this.isLoadingInternalfr">
                            <div class="padding-box">
                                <div class="d-flex align-i-c mb-1">
                                    <h1 class="page-title-text tab-title credit-color">Credit</h1>
                                </div>
                                <div class="d-flex align-i-c mb-1">
                                    <label class="investment-approve-label-text">Account</label>
                                    <p class="investment-company-name pb-0 width-100">
                                        <span *ngIf="(getInternalTransferDetail?.creditEntry?.account?.name != null && getInternalTransferDetail?.creditEntry?.account?.name != '') else elsepart ">{{getInternalTransferDetail?.creditEntry?.account?.name}}</span>
                                    </p>
                                </div>
                                <div class="d-flex align-i-c mb-1">
                                    <label class="investment-approve-label-text">Class</label>
                                    <p class="investment-company-name pb-0 width-100">
                                        <span *ngIf="(getInternalTransferDetail?.creditEntry?.class?.name != null && getInternalTransferDetail?.creditEntry?.class?.name != '') else elsepart ">{{getInternalTransferDetail?.creditEntry?.class?.name}}</span>
                                    </p>
                                </div>
                                <div class="d-flex mb-1">
                                    <label class="investment-approve-label-text">Description</label>
                                    <p class="investment-company-name pb-0 width-100" #creditDesc [ngStyle]="{'height':maxDescHeight + 'px'}">
                                        <span *ngIf="(getInternalTransferDetail?.creditEntry?.description != null && getInternalTransferDetail?.creditEntry?.description != '') else elsepart ">{{getInternalTransferDetail?.creditEntry?.description}}</span>
                                    </p>
                                </div>
                                <div class="d-flex align-i-c mb-1">
                                    <label class="investment-approve-label-text">Amount</label>
                                    <p class="investment-company-name pb-0 width-100">
                                        <span *ngIf="(getInternalTransferDetail?.creditEntry?.amount != null && getInternalTransferDetail?.creditEntry?.amount != '') else elsepart ">{{getInternalTransferDetail?.creditEntry?.amount | currency }}</span>
                                    </p>
                                </div>
                                <div class="d-flex align-i-c mb-1">
                                    <label class="investment-approve-label-text">Net</label>
                                    <p class="investment-company-name pb-0 width-100">
                                        <span *ngIf="(getInternalTransferDetail?.creditEntry?.amount != null && getInternalTransferDetail?.creditEntry?.amount != '') else elsepart ">+{{getInternalTransferDetail?.creditEntry?.amount | currency}}</span>
                                    </p>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>
            </div>
            <div class="margin-none" nz-row [nzGutter]="{ xs: 8, sm: 15, md: 15, lg: 20 }">
                <div nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="12" nzXl="12">
                    <form nz-form [formGroup]="_fS.debitInternalTransferForm" class="estimate-box border-top-0">
                        <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="24">
                            <nz-form-item>
                                <nz-form-control [nzErrorTip]="programError">
                                    <label class="label-text border-bottom" [ngClass]="this.getInternalTransferDetail?.debitEntry?.class == null ? '' : 'required'">Select Program
                                        Period</label>
                                    <nz-select nzShowSearch nzPlaceHolder="Select Program Period" [nzSize]="'default'"
                                        formControlName="debitProgramPeriod" [nzSelectOnTab]="true">
                                        <ng-container *ngFor="let option of listOfProgramPeriodsDebit">
                                            <nz-option *ngIf="!isLoadingPrograms" [nzLabel]="option.label"
                                                [nzValue]="option.id">
                                            </nz-option>
                                        </ng-container>
                                        <nz-option *ngIf="isLoadingPrograms" nzCustomContent>
                                            <span nz-icon nzType="loading" class="loading-icon"></span>
                                            Loading Data...
                                        </nz-option>
                                    </nz-select>
                                    <ng-template #programError let-control>
                                        <ng-container *ngIf="control.hasError('required')">Please select program
                                            period
                                        </ng-container>
                                    </ng-template>
                                </nz-form-control>
                            </nz-form-item>
                        </div>
                        <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="24">
                            <nz-form-item>
                                <nz-form-control [nzErrorTip]="tagError">
                                    <div class="d-flex align-i-c justify-content-space-between"><label
                                            class="label-text" [ngClass]="this.getInternalTransferDetail?.debitEntry?.class == null ? '' : 'required'">
                                            Tags</label></div>
                                            <!--(nzFocus)="getTags(0)"-->
                                    <nz-select #tagsDDDebit nzShowSearch nzPlaceHolder="Select Tag" [nzSize]="'default'"
                                        formControlName="debitTags" [nzSelectOnTab]="true" [nzServerSearch]="true"
                                        (ngModelChange)="checkTagGroupData($event,'DEBIT')" (nzOnSearch)="returnFilteredTags($event,'DEBIT')"
                                        [nzCustomTemplate]="defaultTemplateDebit">
                                        <ng-container *ngFor="let debitOption of listOfTagsDebit">
                                            <ng-container *ngIf="!isLoadingTags">
                                                <nz-option-group [nzLabel]="optionGrouptemplateDebit">
                                                <nz-option *ngFor="let tag of debitOption.Tags" nzCustomContent
                                                    [nzValue]="tag._id" [nzLabel]="tag.Name">
                                                    <span class="tag-list ml-2">
                                                        <span [ngStyle]="{'background-color': debitOption.Color }"
                                                            style="width: 10px;height:30px"></span>&nbsp;{{debitOption.Name}}{{debitOption.Name != 'Uncategorized' ? ':' : ''}}&nbsp;
                                                        <b *ngIf="debitOption.Name != 'Uncategorized'">{{
                                                            tag.Name }}</b>
                                                    </span>
                                                </nz-option>
                                            </nz-option-group>
                                                <ng-template #optionGrouptemplateDebit><span class="d-flex align-i-c"><span class="rountTagGroupColor rount-tag"
                                                    [ngStyle]="{'background-color':debitOption.Color}"></span><span class="tag-group pl-15">{{debitOption.Name}}</span></span></ng-template>
                                            </ng-container>
                                        </ng-container>
                                        <nz-option *ngIf="isLoadingTags" nzDisabled nzCustomContent>
                                            <span nz-icon nzType="loading" class="loading-icon"></span>
                                            Loading Data...
                                        </nz-option>
                                    </nz-select>
                                    <ng-template #defaultTemplateDebit let-selected>
                                        <span class="tag-list ml-2">
                                            <span
                                                [ngStyle]="{'background-color': this.selectedTagDebitGroup?.Color }"
                                                style="width: 10px;height:30px"></span>&nbsp;{{
                                                    selectedTagDebitGroup?.Name
                                            }}{{selectedTagDebitGroup.Name != 'Uncategorized' ? ':' : ''}}&nbsp; <b *ngIf="selectedTagDebitGroup.Name != 'Uncategorized'">{{
                                                selected?.nzLabel }}</b>
                                        </span>
                                    </ng-template>
                                    <ng-template #tagError let-control>
                                        <ng-container *ngIf="control.hasError('required')">Please select
                                            tag</ng-container>
                                    </ng-template>
                                </nz-form-control>
                            </nz-form-item>
                        </div>
                        <div nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="12" nzXl="12">
                            <nz-form-item class="margin-none h-100">
                                <nz-form-control class="switch-box justify-content-center">
                                    <nz-switch formControlName="debitIsNonAlc"></nz-switch>
                                    <label class="switch-label black mr-1">Non-Alc</label>
                                </nz-form-control>
                            </nz-form-item>
                        </div>
                    </form>
                </div>
                <div nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="12" nzXl="12">
                    <form nz-form [formGroup]="_fS.creditInternalTransferForm"
                        class="estimate-box border-top-0 select-program-box">
                        <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="24">
                            <nz-form-item>
                                <nz-form-control [nzErrorTip]="programError">
                                    <label class="label-text border-bottom" [ngClass]="this.getInternalTransferDetail?.creditEntry?.class == null ? '' : 'required'">Select Program
                                        Period</label>
                                    <nz-select nzShowSearch nzPlaceHolder="Select Program Period" [nzSize]="'default'"
                                        formControlName="programPeriod" [nzSelectOnTab]="true">
                                        <ng-container *ngFor="let option of listOfProgramPeriodsCredit">
                                            <nz-option *ngIf="!isLoadingPrograms" [nzLabel]="option.label"
                                                [nzValue]="option.id">
                                            </nz-option>
                                        </ng-container>
                                        <nz-option *ngIf="isLoadingPrograms" nzCustomContent>
                                            <span nz-icon nzType="loading" class="loading-icon"></span>
                                            Loading Data...
                                        </nz-option>
                                    </nz-select>
                                    <ng-template #programError let-control>
                                        <ng-container *ngIf="control.hasError('required')">Please select program
                                            period
                                        </ng-container>
                                    </ng-template>
                                </nz-form-control>
                            </nz-form-item>
                        </div>
                        <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="24">
                            <nz-form-item>
                                <nz-form-control [nzErrorTip]="tagError">
                                    <div class="d-flex align-i-c justify-content-space-between"><label
                                            class="label-text" [ngClass]="this.getInternalTransferDetail?.creditEntry?.class == null ? '' : 'required'">
                                            Tags</label></div>
                                            <!--(nzFocus)="getTags(1)" -->
                                    <nz-select #tagsDDCredit nzShowSearch nzPlaceHolder="Select Tag" [nzSize]="'default'"
                                        formControlName="tags" [nzSelectOnTab]="true" (nzOnSearch)="returnFilteredTags($event,'credit')"
                                        (ngModelChange)="checkTagGroupData($event,'CREDIT')" [nzServerSearch]="true"
                                        [nzCustomTemplate]="defaultTemplateCredit">
                                        <ng-container *ngFor="let creditOption of listOfTagsCredit">
                                            <ng-container *ngIf="!isLoadingTags">
                                                <nz-option-group [nzLabel]="optionGrouptemplate">
                                                <nz-option *ngFor="let tag of creditOption.Tags" nzCustomContent
                                                    [nzValue]="tag._id" [nzLabel]="tag.Name">
                                                    <span class="tag-list ml-2">
                                                        <span [ngStyle]="{'background-color': creditOption.Color }"
                                                            style="width: 10px;height:30px"></span>&nbsp;{{creditOption.Name}}{{creditOption.Name != 'Uncategorized' ? ':' : ''}}&nbsp;
                                                        <b *ngIf="creditOption.Name != 'Uncategorized'">{{
                                                            tag.Name }}</b>
                                                    </span>
                                                </nz-option>
                                            </nz-option-group>
                                                <ng-template #optionGrouptemplate><span class="d-flex align-i-c"><span class="rountTagGroupColor rount-tag"
                                                    [ngStyle]="{'background-color':creditOption.Color}"></span><span class="tag-group pl-15">{{creditOption.Name}}</span></span></ng-template>
                                            </ng-container>
                                        </ng-container>
                                        <nz-option *ngIf="isLoadingTags" nzDisabled nzCustomContent>
                                            <span nz-icon nzType="loading" class="loading-icon"></span>
                                            Loading Data...
                                        </nz-option>
                                    </nz-select>
                                    <ng-template #defaultTemplateCredit let-selecteds>
                                        <span class="tag-list ml-2">
                                            <span
                                                [ngStyle]="{'background-color': this.selectedTagCreditGroup?.Color }"
                                                style="width: 10px;height:30px"></span>&nbsp;{{
                                                    selectedTagCreditGroup?.Name
                                            }}{{selectedTagCreditGroup.Name != 'Uncategorized' ? ':' : ''}}&nbsp; <b *ngIf="selectedTagCreditGroup.Name != 'Uncategorized'">{{
                                                selecteds?.nzLabel }}</b>
                                        </span>
                                        <!-- <span class="rountTagGroupColor" [ngStyle]="{'background-color':this.selectedTagColor}"></span>
                                    {{ selected.nzLabel }} -->
                                    </ng-template>
                                    <ng-template #tagError let-control>
                                        <ng-container *ngIf="control.hasError('required')">Please select
                                            tag</ng-container>
                                    </ng-template>
                                </nz-form-control>
                            </nz-form-item>
                        </div>

                        <div nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="24" nzXl="24">
                            <nz-form-item class="margin-none h-100">
                                <nz-form-control class="switch-box justify-content-center">
                                    <nz-switch formControlName="isNonAlc"></nz-switch>
                                    <label class="switch-label black mr-1">Non-Alc</label>
                                </nz-form-control>
                            </nz-form-item>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
    </ng-container>


    <ng-template #elsepart let-event>
        <span>-</span>
    </ng-template>




    <ng-template #footerTpl>
        <div class="d-flex justify-content-end footer-box">
            <div class="ant-drawer-footer invoice-footer justify-content-end">
                <div class="d-flex">
                    <button nz-button nzType="default" (click)="handleCancel(null)"
                        class="dlt-btn width-100">Close</button>
                    <button nz-button nzType="primary" class="medium-btn small-btn width-100"
                    [nzLoading]="isLoadingTransfer" (click)="updateInternalTransfer()" >Save</button>
                </div>
            </div>
        </div>
    </ng-template>
</nz-modal>